// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  worldId: __t.u64().primaryKey().name("world_id"),
  weekIndex: __t.u64().name("week_index"),
  year: __t.u32(),
  season: __t.u8(),
  week: __t.u8(),
  seasonName: __t.string().name("season_name"),
  seasonNames: __t.array(__t.string()).name("season_names"),
  reckoning: __t.string(),
  biome: __t.string(),
  temperature: __t.string(),
  climate: __t.string(),
  weather: __t.string(),
  startIndex: __t.u64().name("start_index"),
  changedAt: __t.timestamp().name("changed_at"),
});
